import { all, call, put, takeEvery, fork } from 'redux-saga/effects';
import { START_CALL_SESSION, STOP_CALL_SESSION } from '../constants/ActionTypes';
import * as actions from '../actions/CallSession';
import * as alarmsApi from '../api/CallSession';
import { showErrorNotification, showSuccessNotification } from '../actions';
import { CALL_SESSION_STATUSES } from '../constants/Values';

function* startCallSession({ payload }) {
  const { userId, isPrivateCall } = payload;
  try {
    const { data } = yield call(alarmsApi.startCallSession, userId, isPrivateCall);

    yield put(
      actions.startCallSessionSuccess({
        userId,
        responseStatus: data.status,
        directPhoneNumber: data.directPhoneNumber,
      }),
    );
    if (data.status === CALL_SESSION_STATUSES.STARTED) {
      yield put(showSuccessNotification('alarms.call.stared'));
    }
  } catch (error) {
    yield put(actions.startCallSessionError({ userId, error }));
    if (error && error.status === 403) {
      yield put(showErrorNotification(error.messages));
    } else {
      yield put(showErrorNotification('errors.startCall'));
    }
  }
}

function* stopCallSession({ payload }) {
  const { userId } = payload;
  try {
    yield call(alarmsApi.stopCallSession, userId);

    yield put(actions.stopCallSessionSuccess({ userId }));
    yield put(showSuccessNotification('alarms.call.stop'));
  } catch (error) {
    yield put(actions.stopCallSessionError({ userId, error }));
    yield put(showErrorNotification('errors.stopAlarmCall'));
  }
}

export function* startCallSessionSaga() {
  yield takeEvery(START_CALL_SESSION, startCallSession);
}

export function* stopCallSessionSaga() {
  yield takeEvery(STOP_CALL_SESSION, stopCallSession);
}

export default function* rootSaga() {
  yield all([fork(startCallSessionSaga), fork(stopCallSessionSaga)]);
}
